export const primary = '#001A3C';
export const secondary = '#00B085';
export const bodyBlack = '#4A4A4A';
export const errorRed = '#F44336;';
export const white = '#FFFFFF';
export const darkGray = '#B1ADA4';
export const lightGray = '#F8F8F8';
export const darkGreen = '#157245';
export const darkBlue = '#001A3C';
